export enum Screens {
  HOME_ROOT = 'HOME_ROOT',
  HEALTH_ROOT = 'HEALTH_ROOT',
  CARE_ROOT = 'CARE_ROOT',
  BILLING_ROOT = 'BILLING_ROOT',
  MESSAGE_ROOT = 'MESSAGE_ROOT',

  SPLASH = 'Splash',
  APP_UPDATE = 'APP_UPDATE',

  /** Messaging */
  MESSAGES = 'MESSAGES',
  MESSAGES_DETAIL = 'MESSAGES_DETAIL',
  MESSAGES_COMPOSE = 'MESSAGES_COMPOSE',
  MESSAGE_COMPOSE_FIND_PROVIDER = 'MESSAGE_COMPOSE_FIND_PROVIDER',
  MESSAGE_COMPOSE_POOL_SELECT = 'MESSAGE_COMPOSE_POOL_SELECT',

  NETWORK_LOCK_SCREEN = 'dfd.NetworkLock',

  TRANSMIT_LANDING = 'TRANSMIT_LANDING',

  /** Notifications */
  NOTIFICATIONS = 'NOTIFICATIONS',
  NOTIFICATIONS_HIPAA = 'NOTIFICATIONS_HIPAA',
  NOTIFICATIONS_TCPA = 'NOTIFICATIONS_TCPA',

  CLOSE_HEALTH_ADVISORY = 'CLOSE_HEALTH_ADVISORY',

  /** Booking */
  PAST_APPOINTMENTS = 'BOOKING_PAST_APPOINTMENTS',

  /** Updates */
  UPDATES = 'UPDATES',

  /** Help */
  HELP = 'HELP',

  /** Survey */
  SURVEY = 'SURVEY',

  /** TOC Screen */
  TERMS_AND_CONDITIONS = 'TermsAndConditions',

  /** Telehealth Amwell */
  WAITING_ROOM = 'TelehealthWaitingRoom'
}

export const MAX_NUMBER_OF_FILES_MESSAGE = 5;

export const MAX_NUMBER_OF_ADD_DELETE_FILES_MESSAGE = 20;

export const MIME_FILES_ALLOWED = [
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/x-png',
  'image/pjpeg',
  'image/tiff',
  'image/bmp',
  'text/plain',
  'text/html',
  'text/xml',
  'text/rtf',
  'application/postscript',
  'application/rtf',
  'application/pdf',
  'application/msword',
  'application/octet-stream',
  'application/rtf',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'audio/x-ms-wmv',
  'audio/mpeg',
  'audio/basic',
  'video/mp4',
  'video/x-m4v',
  'video/mpeg',
  'video/quicktime',
  'video/mpeg',
  'video/x-ms-wmv'
];
